import React from "react";
import { ITaskSheetId } from "../../Tasksheet.props";
import EditTaskSheet from "./EditTasksheet";



const EditTaskSheetIndex: React.FC<ITaskSheetId> = ({ taskSheetId ,setMethod}) => {

    return (
        <EditTaskSheet taskSheetId={taskSheetId} setMethod={setMethod}/>
    );
}

export default EditTaskSheetIndex;
